import ReactTooltip from 'react-tooltip';

const Tooltip = ReactTooltip;


export {
  Tooltip,
};



// WEBPACK FOOTER //
// ./src/components/elems/Tooltip.js